import React from 'react'
import { renderLogoImages, renderDemographics } from './finder-utils';
import { ACCESS_FOR_ALL_ABILITIES_PLAY } from './data/Constants'

/*
  The ClubTeaser component displays an individual clubs details as part of a listing in the ClubTeaseList component.
  It takes the following properties
  club:  A map that contains club details.
  onDetailsClicked: A callback function to call when the title is clicked on.  Used to display all of the club details
*/
export default class ClubTeaser extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      isLoading: false
    }
  }

  onClick(ev){
    this.setState({isLoading: true}, () => {
      let result = this.props.club.registerFunc.determineRegistrationUrl()
      if (result){
        result.then(()=> {this.setState({isLoading: false})})
      } else {
        this.setState({isLoading: false})
      }
    });
  }


  render(){
    let club = this.props.club;
    let allAbilities = club.details.inclusions !== null && club.details.inclusions.indexOf(ACCESS_FOR_ALL_ABILITIES_PLAY) >= 0;
    
    return (
      <div className="club-teaser club-description-playhq">
        <div className="club-description-header flex">
          <div className="club-description-title">
            <h3 onClick={(ev) => this.props.onDetailsClicked(club)} className="club-heading" tabIndex="0">{club.name}</h3>
          </div>
          <div className="club-distance">
            {club.distance}KM
          </div>
        </div>
        <p className="club-description-inclusion">

            {club.details.demographics &&
              renderDemographics(club.details.demographics)
            }
            
            {/* {allAbilities &&
              <span className="block">All Abilities</span>
            } */}
        </p>
        
        <div className="flex">
          <div className="club-format-logos flex">
              {renderLogoImages(club.details.formats)}
          </div>
          <div className="button-container">
              <a onClick={(ev) => {this.onClick(ev)}} className="btn btn-map btn-club-teaser" tabIndex="0">
                Register <span className="icon icon-chevron-right"></span>
              </a>
          </div>
        </div>
      </div>
    )
  }
}



